// extracted by mini-css-extract-plugin
module.exports = {"hangup_btn_icon":"class_hangup_btn_icon__2H1G4"};